import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, query, onSnapshot } from "firebase/firestore";
import { db } from "../../utils/firebase"; // adjust the import path if necessary
import { useAuth } from "../../utils/AuthContext";
import { Board } from "../../utils/boards"; // Import the Board type

const BoardsMap: React.FC = () => {
  const { currentUser } = useAuth();
  const [boards, setBoards] = useState<Board[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    // Reference the boards subcollection for the current user.
    const boardsRef = collection(db, "users", currentUser.uid, "boards");
    const q = query(boardsRef);

    // Listen for real-time updates
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const boardsData: Board[] = [];
        querySnapshot.forEach((doc) => {
          // Convert the document data to a Board object
          boardsData.push(doc.data() as Board);
        });
        setBoards(boardsData);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching boards:", error);
        setLoading(false);
      }
    );

    // Cleanup listener on unmount
    return () => unsubscribe();
  }, [currentUser]);

  if (loading) {
    return (
      <section className="max-w-[100vw]  px-4 py-8">
        <p>Loading boards...</p>
      </section>
    );
  }

  if (!currentUser) {
    return (
      <section className="max-w-[100vw]  max-w-s px-4 py-8">
        <p>Please log in to view your boards.</p>
      </section>
    );
  }

  if (boards.length === 0) {
    return (
      <section className="max-w-[100vw]  px-4 py-8">
        <p>No boards found. Create one to get started!</p>
      </section>
    );
  }

  return (
    <section className="flex flex-col md:flex-row md:flex-wrap md:items-center md:justify-start gap-4 mb-4 max-w-[100vw]  px-4 py-8">
      {boards.map((board) => (
        <Link to={`/board/${board.id}`} key={board.id} className="block">
          <div className="border rounded-lg overflow-hidden shadow hover:shadow-lg transition-all duration-200">
            <img
              src={board.thumbnail}
              alt="Board thumbnail"
              className="w-full h-40 object-cover"
            />
            <div className="p-4">
              {/* Replace or add more board metadata as needed */}
              <h2 className="text-xl font-semibold">{board.title || "Titre"}</h2>
              {/* For example, if your Board type includes a title, you could show it here */}
            </div>
          </div>
        </Link>
      ))}
    </section>
  );
};

export default BoardsMap;
